import { IconButton } from "@mui/material";

import { NotificationsNormalIcon } from "../../../assets/icons/MUI/LayoutIcons";

import { useNotificationsHandler } from "./useNotificationsHandler";
import NotificationsPopover from "./NotificationsPopover";

const Notifications = () => {
  const {
    notificationsOpen,
    anchorEl,
    activeTab,
    lastSeen,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    setActiveTab,
    handleOpenNotifications,
    handleCloseNotifications,
  } = useNotificationsHandler();

  return (
    <>
      <IconButton onClick={handleOpenNotifications}>
        <NotificationsNormalIcon />
      </IconButton>
      <NotificationsPopover
        notificationsOpen={notificationsOpen}
        anchorEl={anchorEl}
        onClose={handleCloseNotifications}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        data={data}
        lastSeen={lastSeen}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  );
};

export default Notifications;
